'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'chess-rook';
var width = 384;
var height = 512;
var aliases = [9820];
var unicode = 'f447';
var svgPathData = 'M0 0l0 160 64 64 0 160-64 80 0 48 384 0 0-48-64-80 0-160 64-64 0-160-96 0 0 64-48 0 0-64-96 0 0 64-48 0 0-64-96 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChessRook = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;